/** @format */

import { FC, ReactNode } from "react";
import * as Tooltip from "@radix-ui/react-tooltip";

interface IconTooltipProps {
  label: ReactNode;
  children: ReactNode;
  side?: Tooltip.TooltipContentProps["side"];
  sideOffset?: number;
  delayDuration?: number;
}

export const IconTooltip: FC<IconTooltipProps> = ({
  label,
  children,
  side = "top",
  sideOffset = 5,
  delayDuration = 200,
}) => {
  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className="bg-slate-800 text-white border border-slate-600 rounded-md px-2 py-1 text-xs shadow-lg z-50"
            side={side}
            sideOffset={sideOffset}
          >
            {label}
            <Tooltip.Arrow className="fill-slate-800" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default IconTooltip;

